export default function getResource(label, vars = []) {
    const resources = {
        termsPrefix: 'En cliquant sur « Se connecter », vous (1) acceptez la version actuelle de nos ',
        termsAnd: ' et (2) confirmez avoir lu notre ',
        privacyPolicy: 'Politique de confidentialité',
        termsOfUse: 'CONDITIONS D’UTILISATION',
        oauth2TermsPrefix: 'En cliquant sur Se connecter et autoriser l’accès vous acceptez de Sephora ',
        oauth2TermsMiddle: ' et de Sephora ',
        oauth2ChatGPTPrivacy: ', et de ChatGPT ',
        oauth2AuthorizeSuffix: ', et autorisez ChatGPT à accéder à votre compte Beauty Insider, à vos renseignements personnels et à votre panier d’achat (y compris les mises à jour). Vérifiez ou supprimez l’accès en tout temps dans vos paramètres ChatGPT en vous déconnectant de l’appli Sephora.'
    };

    return resources[label];
}
